var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"scroll-progress"}},[_c('div',{staticStyle:{"position":"relative"}},[_c('div',{attrs:{"id":"indicator"}},[_c('div',{staticStyle:{"color":"white","font-size":"18px"}},[_vm._v(" "+_vm._s(_vm.scrollIndicator)+" ")])]),_c('div',{staticClass:"scroll-track"}),_c('div',{staticClass:"scroll-indicator"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }